import config from "../../config";

export class DeviceInfoHeader {
  public platform: string;
  public os: string;
  public osVersion: string;
  public device: string;
  public deviceClass: string;
  public clientVersion: string;
  public clientVersionCode: number;
}

export function getDeviceHeader():string {
  const header = new DeviceInfoHeader();
  header.platform = "WEB";
  header.os = navigator.platform;
  header.deviceClass = getDeviceClass();
  header.clientVersion = config.buildVersion;

  return JSON.stringify(header);
}

function getDeviceClass():string {
  const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  if(vw <= 768) {
    return "MOBILE";
  }
  if (vw <= 1024) {
    return "TABLET"
  }
  return "DESKTOP"
}
